import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";

const API_URL = "/api";

export default function TransactionLog() {
  const { id } = useParams();
  const [companyNew, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companyID, setCompanyID] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [transactionID, setTransactionID] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/transcationInfoDetail/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setCompany(data);
        setCompanyID(data?.COMPANYID);
        setTransactionID(data?.TRANSACTIONID);
        console.log("Company:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    const fetchTransactionDetails = async () => {
      try {
        const response = await fetch(
          `${API_URL}/getTransactionDetailsListByCompanyId/${companyID}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTransactionData("Hello:", data);

        console.log("Transaction Data", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionDetails();
  }, [companyID]);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData({ ...companyNew }); // reset the form
    setIsEditing(false);
  };

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back
            </NavLink>
            <br />
            <br />
            <NavLink to={`/TransactionLog/${id}`} className="btn btn-dark ms-2">
              Transaction Information
            </NavLink>

            <NavLink
              to={`/ViewTransactionList/${transactionID}`}
              className="btn btn-outline-secondary  ms-2"
            >
              Loan Details
            </NavLink>
            <NavLink
              to={`/Drawdowns/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Drawdowns
            </NavLink>
            <NavLink
              to={`/ApplicationChecklist/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Application Checklist
            </NavLink>
            <NavLink
              to={`/ScoreCard/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scorecard
            </NavLink>
            <NavLink
              to={`/TransactionSummary/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Transaction Summary
            </NavLink>
            <NavLink
              to={`/TermSheet/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Term Sheet
            </NavLink>
            <NavLink
              to={`/Payments/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Payments
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Transaction Information</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData({ ...companyNew });
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !companyNew ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <table className="table table-bordered">
                  <tbody>
                    {[
                      {
                        label: "1ST PAYOUT CALCULATION",
                        key: "1STPAYOUTCALCULATION",
                      },
                      {
                        label: "2nd PAYOUT CALCULATION",
                        key: "2STPAYOUTCALCULATION",
                      },
                      {
                        label: "2025 PROGRAMME FEE CALCULATION",
                        key: "2025PROGRAMMEFEECALCULATION",
                      },
                      { label: "2025 PROGRAM TAG", key: "2025PROGRAMTAG" },
                      {
                        label: "ACCOUNTING RECORD",
                        key: "ACCOUNTINGRECORD",
                      },
                      { label: "ACT TENOR DAYS", key: "ACTTENOR_DAYS" },
                      {
                        label: "ACTUAL CASH DISBURSEMENT HK$",
                        key: "ACTUALCASHDISBURSEMENT_HK$",
                      },
                      {
                        label: "ACTUAL PAYMENT AMOUNT 1STPAYMENT",
                        key: "ACTUALPAYMENTAMOUNT_1STPAYMENT",
                      },
                      {
                        label: "ACTUAL PAYMENT AMOUNT 2NDPAYMENT",
                        key: "ACTUALPAYMENTAMOUNT_2NDPAYMENT",
                      },
                      {
                        label: "ACTUAL PROGRAMME FEE PAYMENT",
                        key: "ACTUALPROGRAMMEFEEPAYMENT",
                      },
                      {
                        label: "ACTUAL RIVERCHAIN REFERRAL REVENUE",
                        key: "ACTUALRIVERCHAINREFERRALREVENUE",
                      },
                      {
                        label: "ACTUAL RIVERCHAIN REVENUE",
                        key: "ACTUALRIVERCHAINREVENUE",
                      },
                      {
                        label: "ACTUAL THIRD PARTY REFERRAL FEES",
                        key: "ACTUALTHIRD_PARTYREFERRALFEES",
                      },
                      {
                        label: "ACTUAL TRANSACTION HPY PERCENTAGE",
                        key: "ACTUALTRANSACTIONHPYPERCENTAGE",
                      },
                      {
                        label: "ACTUAL TRANSACTION REVENUE",
                        key: "ACTUALTRANSACTIONREVENUE",
                      },
                      {
                        label: "ACTUAL VS EXPECTEDINCOME",
                        key: "ACTUALVSEXPECTEDINCOME",
                      },
                      {
                        label: "ACTUAL VS EXPECTEDTENOR",
                        key: "ACTUALVSEXPECTEDTENOR",
                      },
                      {
                        label: "ADDITIONAL DISCOUNT CHARGE PAID",
                        key: "ADDICTIONALDISCOUNTCHARGEPAID",
                      },
                      {
                        label: "ADMIN FEES PAID",
                        key: "ADMINFEESPAID",
                      },
                      {
                        label: "ADMINFEE PERCENTAGE",
                        key: "ADMINFEE_PERCENTAGE",
                      },
                      {
                        label: "AGING GROUP",
                        key: "AGINGGROUP",
                      },
                      {
                        label: "AMOUNT REPAID",
                        key: "AMOUNTREPAID",
                      },
                      {
                        label: "ANNUALIZED ACTUAL HPY PERCENTAGE",
                        key: "ANNUALIZEDACTUALHPYPERCENTAGE",
                      },
                      {
                        label: "ANNUALIZED EXPHPY PERCENTAGE",
                        key: "ANNUALIZEDEXPHPYPERCENTAGE",
                      },
                      {
                        label: "APPLICABLE PERCENTAGE FOR THE TRANSACTION",
                        key: "APPLICABLEPERCENTAGEFORTHETRANSACTION",
                      },
                      {
                        label: "APPROVAL CRITERIA",
                        key: "APPROVALCRITERIA",
                      },
                      {
                        label: "APPROVAL DATE",
                        key: "APPROVALDATE",
                      },
                      {
                        label: "BANK ACCOUNT NAME",
                        key: "BANKACCOUNTNAME",
                      },
                      {
                        label: "BANK ACCOUNT NO",
                        key: "BANKACCOUNTNO",
                      },
                      {
                        label: "BANK CODE",
                        key: "BANKCODE",
                      },
                      {
                        label: "BORROWER",
                        key: "BORROWER",
                      },
                      {
                        label: "BORROWER RATING",
                        key: "BORROWERRATING",
                      },
                      {
                        label: "CLOSING DATE",
                        key: "CLOSINGDATE",
                      },
                      {
                        label: "COLOG CHECK",
                        key: "COLOGCHECK",
                      },
                      {
                        label: "CONTRACT NO",
                        key: "CONTRACTNO",
                      },
                      {
                        label: "COUNTRY",
                        key: "COUNTRY",
                      },
                      {
                        label:
                          "CREDIT LINE OR WT FACTORING FINAL MATURITY DATE",
                        key: "CREDITLINEORWTFACTORINGFINALMATURITYDATE",
                        type: "date",
                      },
                      {
                        label: "DATE OF REPAYMENT",
                        key: "DATEOFREPAYMENT",
                      },
                      {
                        label: "DAYS OVERDUE DAYS",
                        key: "DAYSOVERDUE_DAYS",
                      },
                      {
                        label: "DELINQUENCY GROUP",
                        key: "DELINQUENCYGROUP",
                      },
                      {
                        label: "DISBURSEMENTAMOUNT AMOUNTREPAID",
                        key: "DISBURSEMENTAMOUNT_AMOUNTREPAID",
                      },
                      {
                        label: "DISBURSEMENT AMOUNT HK",
                        key: "DISBURSEMENTAMOUNT_HK$",
                      },
                      {
                        label: "DISBURSEMENT DATE",
                        key: "DISBURSEMENTDATE",
                      },
                      {
                        label: "DISCOUNT CHARGE PAID",
                        key: "DISCOUNTCHARGEPAID",
                      },
                      {
                        label: "DISCOUNT RATE PERCENTAGE",
                        key: "DISCOUNTRATE_PERCENTAGE",
                      },
                      {
                        label: "DUE FOR PAYMENT",
                        key: "DUEFORPAYMENT",
                      },
                      {
                        label: "DUE FOR PAYMENT 2025 PROGRAM",
                        key: "DUEFORPAYMENT2025PROGRAM",
                      },
                      {
                        label: "EARNED REVENUE FOR FEE CALCS",
                        key: "EARNEDREVENUEFORFEECALCS",
                      },
                      {
                        label: "EIF REMAINING AV AILABILITY PERIOD",
                        key: "EIFREMAININGAVAILABILITYPERIOD",
                      },
                      {
                        label: "EMPLOYER",
                        key: "EMPLOYER",
                      },
                      {
                        label: "EMPLOYER PARENT COMPANIES",
                        key: "EMPLOYERPARENTCOMPANIES",
                      },
                      {
                        label: "EST TENOR DAYS",
                        key: "ESTTENOR_DAYS",
                      },
                      {
                        label: "EXP DAYS LEFT TO MATURITY DAYS",
                        key: "EXPDAYSLEFTTOMATURITY_DAYS",
                      },
                      {
                        label: "EXP DAYS LEFT TO NEXT PAYMENT DAYS",
                        key: "EXPDAYSLEFTTONEXTPAYMENT_DAYS",
                      },
                      {
                        label: "EXPECTED RIVERCHAIN REFERRAL REVENUE",
                        key: "EXPECTEDRIVERCHAINREFERRALREVENUE",
                      },
                      {
                        label: "EXPECTED RIVERCHAIN REVENUE",
                        key: "EXPECTEDRIVERCHAINREVENUE",
                      },
                      {
                        label: "EXPECTED THIRD PARTY REFERRAL FEES",
                        key: "EXPECTEDTHIRD_PARTYREFERRALFEES",
                      },
                      {
                        label: "EXPECTED TOTAL PAYMENT AMOUNT",
                        key: "EXPECTEDTOTALPAYMENTAMOUNT",
                      },
                      {
                        label: "EXPECTED TRANSACTION REVENUE",
                        key: "EXPECTEDTRANSACTIONREVENUE",
                      },
                      {
                        label: "EXP NEXT PRINCIPAL REPAYMENT AMOUNT",
                        key: "EXPNEXTPRINCIPALREPAYMENTAMOUNT",
                      },
                      {
                        label: "EXPT NEXT PAYMENT DATE",
                        key: "EXPTNEXTPAYMENTDATE",
                      },
                      {
                        label: "EXP TRANSACTION HPY PERCENTAGE",
                        key: "EXPTRANSACTIONHPYPERCENTAGE",
                      },
                      {
                        label: "FACILITY LIMIT",
                        key: "FACILITYLIMIT",
                      },
                      {
                        label: "FIRST PAYMENT RATIO",
                        key: "FIRSTPAYMENTRATIO",
                      },
                      {
                        label: "GROSS EXPOSURE",
                        key: "GROSSEXPOSURE",
                      },
                      {
                        label: "INTEREST PAID",
                        key: "INTERESTPAID",
                      },
                      {
                        label: "INTEREST RATE PERCENTAGE PA",
                        key: "INTERESTRATE_PERCENTAGEPA",
                      },
                      {
                        label: "INVOICE DATE",
                        key: "INVOICEDATE",
                        type: "date",
                      },
                      {
                        label: "INVOICE OR RECEIVABLE NO",
                        key: "INVOICEORRECEIVABLENO",
                      },
                      {
                        label: "INVOICE VALUE",
                        key: "INVOICEVALUE",
                      },
                      {
                        label: "LENDER",
                        key: "LENDER",
                      },
                      {
                        label: "LIVE EXPOSURE",
                        key: "LIVEEXPOSURE",
                      },
                      {
                        label: "MAINCONTRACTOR",
                        key: "MAINCONTRACTOR",
                      },
                      {
                        label: "MATURITY DATE",
                        key: "MATURITYDATE",
                      },
                      {
                        label: "NO OF CONTRACTS USED FOR DRAWDOWN",
                        key: "NOOFCONTRACTSUSEDFORDRAWDOWN",
                      },
                      {
                        label: "OVER DUE CHARGES PAID",
                        key: "OVERDUECHARGESPAID",
                      },
                      {
                        label:
                          "OVER DUE OR ADDITIONAL DISCOUNT CHARGES PERCENTAGE",
                        key: "OVERDUEORADDITIONALDISCOUNTCHARGES_PERCENTAGE",
                      },
                      {
                        label: "PAYEENAME",
                        key: "PAYEENAME",
                      },
                      {
                        label: "PAYMENT DATE  1ST PAYMENT",
                        key: "PAYMENTDATE_1STPAYMENT",
                      },
                      {
                        label: "PAYMENT DATE 2ND PAYMENT",
                        key: "PAYMENTDATE_2NDPAYMENT",
                      },
                      {
                        label: "POTENTIAL REVENUE",
                        key: "POTENTIALREVENUE",
                      },
                      {
                        label: "PRINCIPAL AMOUNT OUTSTANDING",
                        key: "PRINCIPALAMOUNTOUTSTANDING",
                      },
                      {
                        label: "PRODUCT",
                        key: "PRODUCT",
                      },
                      {
                        label: "PROJECT NAME",
                        key: "PROJECTNAME",
                      },
                      {
                        label: "PROJECT TAG",
                        key: "PROJECTTAG",
                      },
                      {
                        label: "PROVISION RATE",
                        key: "PROVISIONRATE",
                      },
                      {
                        label: "PROVISIONS",
                        key: "PROVISIONS",
                      },
                      {
                        label: "REJECTION TAG",
                        key: "REJECTIONTAG",
                      },
                      {
                        label: "REPAYMENT DATE",
                        key: "REPAYMENTDATE",
                      },
                      {
                        label: "REVISED MATURITY DATE",
                        key: "REVISEDMATURITYDATE",
                      },
                      {
                        label: "RISK GROUP",
                        key: "RISKGROUP",
                      },
                      {
                        label: "RIVERCHAIN REBATES PAID",
                        key: "RIVERCHAINREBATESPAID",
                      },
                      {
                        label: "RIVERCHAIN REFERRAL FEE PERCENTAGE",
                        key: "RIVERCHAINREFERRALFEE_PERCENTAGE",
                      },
                      {
                        label: "SALES LEAD",
                        key: "SALESLEAD",
                      },
                      {
                        label: "SECURITY TYPE",
                        key: "SECURITYTYPE",
                      },
                      {
                        label: "SECURITY VALUE",
                        key: "SECURITYVALUE",
                      },
                      {
                        label: "SECURITY VALUE DATE",
                        key: "SECURITYVALUEDATE",
                        type: "date",
                      },
                      {
                        label: "STATUS",
                        key: "STATUS",
                      },
                      {
                        label: "STATUS 2",
                        key: "STATUS2",
                      },
                      {
                        label: "STATUS OF 1ST PAYMENT",
                        key: "STATUSOF1STPAYMENT",
                      },
                      {
                        label: "STATUS OF 2ND PAYMENT",
                        key: "STATUSOF2NDPAYMENT",
                      },
                      {
                        label: "STATUS OF PROGRAMME FEE PAYMENT",
                        key: "STATUSOFPROGRAMMEFEEPAYMENT",
                      },
                      {
                        label: "TARGET DISBURSEMENT DATE",
                        key: "TARGETDISBURSEMENTDATE",
                        type: "date",
                      },
                      {
                        label: "THIRD PARTY REFERRAL FEE PERCENTAGE",
                        key: "THIRD_PARTYREFERRALFEE_PERCENTAGE",
                      },
                      {
                        label: "THIRD PARTY REFERRER",
                        key: "THIRD_PARTYREFERRER",
                      },
                      {
                        label: "TRANCHE",
                        key: "TRANCHE",
                      },
                      {
                        label: "TRANSACTION AMOUNT",
                        key: "TRANSACTIONAMOUNT",
                      },
                      {
                        label: "TRANSACTION ID",
                        key: "TRANSACTIONID",
                      },
                      {
                        label: "TRANSACTIONID 2",
                        key: "TRANSACTIONID2",
                      },
                      {
                        label: "TRANSACTIONRATING",
                        key: "TRANSACTIONRATING",
                      },
                      {
                        label: "TYPE",
                        key: "TYPE",
                      },
                    ].map(({ label, key, type }) => (
                      <tr key={key}>
                        <td>{label}</td>
                        <td
                          style={{
                            textAlign: "right",
                            backgroundColor: "#fdf3d0",
                            width: "50%",
                          }}
                        >
                          {isEditing ? (
                            type === "date" ? (
                              <input
                                type="date"
                                value={
                                  formData?.[key]
                                    ? new Date(formData[key])
                                        .toISOString()
                                        .split("T")[0]
                                    : ""
                                }
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [key]: e.target.value,
                                  }))
                                }
                                className="form-control form-control-sm"
                                style={{ textAlign: "right" }}
                              />
                            ) : (
                              <input
                                type="text"
                                value={formData?.[key] ?? ""}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [key]: e.target.value,
                                  }))
                                }
                                className="form-control form-control-sm"
                                style={{ textAlign: "right" }}
                              />
                            )
                          ) : type === "date" ? (
                            companyNew?.[key] ? (
                              formatDateToDDMMYYYY(companyNew[key])
                            ) : (
                              ""
                            )
                          ) : (
                            companyNew?.[key]
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
